export const validationRegexTypes = {
  CompanyRegistration: /^(([a-zA-Z]{2}[0-9]{6})|([0-9]{8}))$/,
  WholeNumber: /^\d*$/,
  Email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  Postcode: /^([A-Z]{1,2})([0-9][0-9A-Z]?)(\s?)([0-9])([ABDEFGHJLNPQRSTUWXYZ]{2})$/i,
  Telephone: /^\+?[0-9()\s-]{0,50}$/
}